import React, { useState } from 'react';
import { Form, Modal } from "react-bootstrap";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import LoadingButtonWithForm from '../../components/LoadingButtonWithForm';
import { responseError } from '../../helpers/responseHandler';
import { useAddExpenceMutation, useEditExpenceMutation } from '../../redux/services/ExpenceService';
import { sweetAlert } from '../../utils';
import { useGetSelectDriversQuery } from '../../redux/services/DriverService';
import SearchSelect from '../../components/SearchSelect';

const ExpenseCreateModal = ({ show, handleClose, isEdit }) => {
    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;

    const navigate = useNavigate()
    // const { state: { isEdit } } = useLocation()

    let {
        control,
        register,
        handleSubmit,
        setValue,
        watch,
        reset,
        formState: { errors },
    } = useForm()

    const [addRequest, { isLoading: addLoading }] = useAddExpenceMutation()
    const [editRequest, { isLoading: editLoading }] = useEditExpenceMutation()

    const { data: data2 } = useGetSelectDriversQuery()
    const drivers = data2?.response?.data




    const onSubmit = async (data) => {
        data['driver_id'] = data?.driver_id?.value > 0 ? data?.driver_id?.value : ''
        data['end'] = data?.check ? data?.end : data?.start

        if (isEdit) {
            const newForm = { ...data }
            await editRequest({ id: isEdit?.id, newForm }).unwrap()
                .then((res) => {
                    if (res?.status) {
                        sweetAlert(res?.message, 'success')
                        // navigate(-1)
                        handleClose()
                    }
                })
                .catch((err) => {
                    responseError(err)
                })
        } else {
            const newForm = { ...data }
            await addRequest(newForm).unwrap()
                .then((res) => {
                    if (res?.status) {
                        sweetAlert(res?.message, 'success')
                        // navigate(-1)
                        handleClose()
                    }
                })
                .catch((err) => {
                    responseError(err)
                })
        }
    }

    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5">Create Expense</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit(onSubmit)} id='driver-status'>
                        <Form.Group className="mb-3">
                            <Form.Label>Select Driver Name:</Form.Label>
                            <Controller
                                name="driver_id"
                                control={control}
                                defaultValue={
                                    (isEdit?.driver_id && isEdit?.driver) ?
                                        (
                                            { label: isEdit?.driver?.full_name, value: isEdit?.driver?.id }
                                        ) :
                                        null
                                }
                                rules={{
                                    required: true
                                }}
                                render={({ field }) => (
                                    <>
                                        <SearchSelect
                                            options={drivers?.map((item) => ({ value: item?.id, label: item?.full_name }))}
                                            field={field}
                                            placeholder={"Select Approved Driver"}
                                        />
                                        {errors.driver_id && <div className="invalid-feedback d-block">This field is required</div>}
                                    </>

                                )}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Expense Type:</Form.Label>
                            <Controller
                                name="type"
                                control={control}
                                defaultValue={isEdit?.type || ''}
                                rules={{
                                    required: true
                                }}
                                render={({ field }) => (
                                    <Form.Control
                                        {...field}
                                        type="text" placeholder="Enter expense type"
                                        isInvalid={errors.type}
                                    />
                                )}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Expense Description:</Form.Label>
                            <Controller
                                name="description"
                                control={control}
                                defaultValue={isEdit?.description || ''}
                                rules={{
                                    required: true
                                }}
                                render={({ field }) => (
                                    <Form.Control
                                        {...field}
                                        type="text" placeholder="Enter expense description"
                                        isInvalid={errors.description}
                                    />
                                )}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Expense Amount:</Form.Label>
                            <div className="input-group align-items-center">
                                <span className="input-group-addon">$</span>
                                <Controller
                                    name="amount"
                                    control={control}
                                    defaultValue={isEdit?.amount || ''}
                                    rules={{
                                        required: true
                                    }}
                                    render={({ field }) => (
                                        <Form.Control
                                            {...field}
                                            type="number" placeholder="Enter amount"
                                            isInvalid={errors.amount}
                                        />
                                    )}
                                />
                            </div>
                        </Form.Group>



                        <Form.Group className="mb-3">
                            <Form.Label className='d-flex gap-2'>
                                {watch('check') ? 'Start' : ''}  Date:
                                <Form.Group className="mb-3">
                                    <Controller
                                        name="check"
                                        control={control}
                                        defaultValue={isEdit?.check || false}
                                        render={({ field }) => (
                                            <Form.Check // prettier-ignore
                                                type="switch"
                                                id="custom-switch"
                                                //                                        label=""
                                                {...field}
                                            />
                                        )}
                                    />
                                </Form.Group>
                            </Form.Label>
                            <Controller
                                name="start"
                                control={control}
                                defaultValue={isEdit?.start || ''}
                                rules={{
                                    required: true
                                }}
                                render={({ field }) => (
                                    <Form.Control
                                        {...field}
                                        type="date" placeholder="Enter expense date manually"
                                        isInvalid={errors.start}
                                    />
                                )}
                            />
                        </Form.Group>
                        {watch('check') && (
                            <Form.Group className="mb-3">
                                <Form.Label>End Date:</Form.Label>
                                <Controller
                                    name="end"
                                    control={control}
                                    defaultValue={isEdit?.end || ''}
                                    rules={{
                                        required: true
                                    }}
                                    render={({ field }) => (
                                        <Form.Control
                                            {...field}
                                            type="date" placeholder="Enter expense date manually"
                                            isInvalid={errors.end}
                                        />
                                    )}
                                />
                            </Form.Group>
                        )}


                        {/* Expense Date Range */}
                        <Form.Group className="mb-3 d-none">
                            <Form.Label>Expense Date Range:</Form.Label>
                            <DatePicker
                                selectsRange
                                startDate={startDate}
                                endDate={endDate}
                                onChange={(update) => setDateRange(update)}
                                isClearable
                                placeholderText="Select date range"
                                className="form-control w-100"
                            />
                        </Form.Group>

                    </Form>
                </Modal.Body>
                <Modal.Footer className="border-0">
                    <LoadingButtonWithForm
                        isLoading={editLoading ? editLoading : addLoading}
                        name="Save"
                        form="driver-status"
                    />
                </Modal.Footer>

            </Modal>
        </>
    );
};

export default ExpenseCreateModal;